var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-modal-frame",
    {
      attrs: { "is-showing": _vm.isShowing, "has-actions": "" },
      on: { "close-modal": _vm.closeModal },
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _c(
          "section",
          {
            staticStyle: {
              "margin-inline": "calc(-1 * var(--card-horizontal-padding))",
              "margin-top": "calc(-1 * var(--card-vertical-padding))",
              "border-radius":
                "var(--card-border-radius) var(--card-border-radius) 0 0",
              overflow: "hidden",
            },
          },
          [
            _c("img", {
              staticStyle: {
                width: "100%",
                height: "100%",
                "object-fit": "cover",
              },
              attrs: {
                src: "https://img.fortawesome.com/1ce05b4b/wa-modal-promo.png",
                alt: "Web Awesome Logo Graphic",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("section", { staticClass: "text-left" }, [
          _c("h2", { staticClass: "margin-top-md margin-bottom-2xs" }, [
            _vm._v("Web Awesome has landed!"),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        Explore the biggest and best open-source library of meticulously designed, highly customizable, and framework-agnostic UI components. And for a limited time, get 20% off a Pro subscription.\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "display-flex flex-column flex-items-center tablet:flex-row tablet:flex-content-between",
          staticStyle: {
            "--button-margin-bottom": "0",
            gap: "var(--spacing-lg)",
          },
          attrs: { slot: "actions" },
          slot: "actions",
        },
        [
          _c(
            "a",
            {
              staticClass: "button block",
              attrs: {
                href: "https://webawesome.com/?utm_source=fontawesome&utm_medium=modal&utm_campaign=launch",
                target: "_blank",
              },
            },
            [
              _c("i", {
                staticClass:
                  "fa-solid fa-xl fa-arrow-up-right-from-square margin-right-sm",
              }),
              _vm._v("\n      Explore Web Awesome\n    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "button block",
              staticStyle: {
                "--button-color": "var(--fa-navy)",
                "--button-background": "#FFAF99",
                "--button-hover-background": "#F36944",
                "--button-hover-border-color": "var(--fa-navy)",
              },
              attrs: {
                href: "https://webawesome.com/purchase?utm_source=fontawesome&utm_medium=modal&utm_campaign=launch",
                target: "_blank",
              },
            },
            [
              _c("i", {
                staticClass: "fa-solid fa-xl fa-rocket-launch margin-right-sm",
              }),
              _vm._v("\n      20% Off Launch Sale\n    "),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }